import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/lib/AuthContext';
import SellerRegistration from '@/pages/SellerRegistration';
import { WishlistProvider } from '@/lib/WishlistContext';
import { AuthCallback } from '@/components/AuthCallback';
import ScrollToTop from '@/components/ScrollToTop';
import Layout from '@/components/Layout';
import ProtectedRoute from '@/components/ProtectedRoute';
import Home from '@/pages/Home';
import NearbyStores from '@/pages/NearbyStores';
import Products from '@/pages/Products';
import CategoryLanding from '@/pages/CategoryLanding';
import ProductDetail from '@/pages/ProductDetail';
import Cart from '@/pages/Cart';
import Checkout from '@/pages/Checkout';
import OrderConfirmed from '@/pages/OrderConfirmed';
import MyOrders from '@/pages/MyOrders';
import MyAccount from '@/pages/MyAccount';
import Wishlist from '@/pages/Wishlist';
import HowItWorks from '@/pages/HowItWorks';
import MiLealtad from '@/pages/MiLealtad';
import TrackOrder from '@/pages/TrackOrder';
import Login from '@/pages/Login';
import ResetPassword from '@/pages/ResetPassword';
import Terminos from '@/pages/legal/Terminos';
import Privacidad from '@/pages/legal/Privacidad';
import Devoluciones from '@/pages/legal/Devoluciones';
import Contacto from '@/pages/Contacto';
import NotFound from '@/pages/NotFound';
import SellerPortal from '@/pages/SellerPortal';
import SellerLogin from '@/pages/SellerLogin';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentCancel from '@/pages/PaymentCancel';
import UserGuide from '@/pages/UserGuide';
import { I18nProvider } from '@/lib/i18n';
import { InstallBanner } from '@/components/InstallBanner';

const AppRouter = () => {
  const location = useLocation();
  const { user, loading } = useAuth();
  if (new URLSearchParams(location.hash.slice(1)).has('session_id')) return <AuthCallback />;
  if (!loading && user?.registration_restricted && location.pathname !== '/registro-vendedor') return <Navigate to="/registro-vendedor" replace />;
  return <><ScrollToTop /><Routes>
    <Route path="/registro-vendedor" element={<ProtectedRoute><SellerRegistration /></ProtectedRoute>} />
    <Route path="/login" element={<Login />} />
    <Route path="/seller-login" element={<SellerLogin />} />
    <Route path="/guia" element={<UserGuide />} />
    <Route path="/guia-del-usuario" element={<Navigate to="/guia" replace />} />
    <Route path="/payment/success" element={<PaymentSuccess />} />
    <Route path="/payment/cancel" element={<PaymentCancel />} />
    <Route path="/restablecer" element={<ResetPassword />} />
    <Route path="/seller/*" element={<ProtectedRoute><SellerPortal /></ProtectedRoute>} />
    <Route path="/platform/*" element={<ProtectedRoute adminOnly><SellerPortal platformMode /></ProtectedRoute>} />
    <Route path="/admin/*" element={<Navigate to="/platform" replace />} />
    <Route element={<Layout />}>
      <Route path="/" element={<Home />} />
      <Route path="/tiendas-cercanas" element={<NearbyStores />} />
      <Route path="/productos" element={<Products />} />
      <Route path="/categoria/:id" element={<CategoryLanding />} />
      <Route path="/producto/:id" element={<ProductDetail />} />
      <Route path="/carrito" element={<Cart />} />
      <Route path="/como-funciona" element={<HowItWorks />} />
      <Route path="/terminos" element={<Terminos />} />
      <Route path="/privacidad" element={<Privacidad />} />
      <Route path="/devoluciones" element={<Devoluciones />} />
      <Route path="/contacto" element={<Contacto />} />
      <Route path="/mi-lealtad" element={<MiLealtad />} />
      <Route path="/rastrear" element={<TrackOrder />} />
      <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
      <Route path="/orden-confirmada" element={<ProtectedRoute><OrderConfirmed /></ProtectedRoute>} />
      <Route path="/mis-pedidos" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
      <Route path="/mi-cuenta" element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />
      <Route path="/mi-lista-de-deseos" element={<ProtectedRoute><Wishlist /></ProtectedRoute>} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes></>;
};
export default function App() {
  return <div className="App"><ThemeProvider attribute="class" defaultTheme="system" enableSystem><AuthProvider><WishlistProvider><BrowserRouter><I18nProvider><AppRouter /><InstallBanner /><Toaster position="top-center" visibleToasts={3} closeButton /></I18nProvider></BrowserRouter></WishlistProvider></AuthProvider></ThemeProvider></div>;
}
